import { FunctionComponent } from 'react';
import styled from 'styled-components';

type Props = {
  text?: string;
};

const StyledOr = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border-radius: 5px;
  margin: 16px 0;

  &:before,
  &:after {
    width: 30%;
    display: inline-block;
    height: 2px;
    background: white;
    content: '';
  }

  &:before {
    margin-right: 15px;
  }

  &:after {
    margin-left: 15px;
  }
`;

const Or: FunctionComponent<Props> = ({ text }) => {
  return <StyledOr>{text || 'Or'}</StyledOr>;
};

export default Or;
